import { makeNoteMockData } from '../../modules/noteMockDataFactory'
import type { IOpportunityMSNote } from '~/types/note/models'

export const {
  getNoteListData: getOpportunityMSNoteListData,
  getNoteDataById: getOpportunityMSNoteDataById,
  getNoteListDataByParentId: getOpportunityMSNoteListDataByOMSId,
} = makeNoteMockData<IOpportunityMSNote>({
  entityName: 'opportunityMasterService',
  storageKeyPrefix: 'opportunityms',
})
